import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();
export const CartProvider = ({ children, menu }) => {
  const [pizzaBoxes, setPizzaBoxes] = useState({});
  const updatePizzaBoxes = (products) => {
    console.log('Обновляем коробки для пиццы:', products);
    setPizzaBoxes(products);
  };

  const loadCartFromLocalStorage = () => {
    const savedCart = localStorage.getItem('cart');
    return savedCart ? JSON.parse(savedCart) : [];
  };
  const [cart, setCart] = useState(loadCartFromLocalStorage);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
    updatePizzaBoxesCount(cart);
  }, [cart]);

  const PIZZA_30_PARENT = '8ef98e04-a061-4008-8cd0-e271491de95a';
  const PIZZA_40_PARENT = '2ff9c9e0-7018-45e9-9291-39ab3afa9303';

  const updatePizzaBoxesCount = (updatedCart) => {
    let pizzaBox30 = 0;
    let pizzaBox40 = 0;

    updatedCart.forEach((item) => {
      if (item.parentGroup === PIZZA_30_PARENT) {
        pizzaBox30 += item.amount;
      }
      if (item.parentGroup === PIZZA_40_PARENT) {
        pizzaBox40 += item.amount;
      }
      if (item.name.toLowerCase().includes('пирог') || item.name.toLowerCase().includes('хачапури по-мегрельски')) {
        pizzaBox30 += item.amount;
      }
    });

    const updatedPizzaBoxes = {};

    if (pizzaBox30 > 0) {
      updatedPizzaBoxes.pizzaBox30 = {
        id: 'b1b6687f-41ed-4ee2-a7de-bf93203ad2f1',
        name: 'коробка для пиццы 30 см',
        price: 30,
        amount: pizzaBox30,
        productGroupId: '30df600f-7e4c-49d9-82f1-12ed05f47e3b',
      };
    }

    if (pizzaBox40 > 0) {
      updatedPizzaBoxes.pizzaBox40 = {
        id: '4ae75274-0082-4139-a6e2-7bec7bfea924',
        name: 'коробка для пиццы 40 см',
        price: 40,
        amount: pizzaBox40,
        productGroupId: '83a6eadc-c41d-47ff-8ff3-7be28aace7fb',
      };
    }

    setPizzaBoxes(updatedPizzaBoxes);
  };

  const addToCart = (product) => {
    const uniqueKey = `${product.id}-${(product.modifiers || [])
      .map((mod) => mod.id)
      .join('-')}`;

    setCart((prevCart) => {
      const existingProduct = prevCart.find((item) => item.key === uniqueKey);

      if (existingProduct) {
        return prevCart.map((item) =>
          item.key === uniqueKey
            ? { ...item, amount: item.amount + 1 }
            : item
        );
      }

      const newProduct = {
        key: uniqueKey,
        productId: product.id,
        name: product.name,
        price: product.price,
        image: product.image,
        amount: 1,
        groupId: product.groupId,
        parentGroup: product.parentGroup,
        totalPrice: totalPrice,
        modifiers: (product.modifiers || []).map((mod) => ({
          productId: mod.id,
          name: mod.name,
          price: mod.price,
          amount: mod.amount,
          productGroupId: mod.productGroupId,
        })),
      };

      return [...prevCart, newProduct];
    });
  };

  const clearCart = () => {
    setCart([]);
  };

  const totalPrice = cart.reduce((sum, product) => {
    const productPrice = product.amount * product.price;
    const modifiersPrice = (product.modifiers || []).reduce(
      (modSum, mod) => modSum + mod.price * mod.amount,
      0
    );
    return sum + productPrice + modifiersPrice;
  }, 0) +
    (pizzaBoxes.pizzaBox30 ? pizzaBoxes.pizzaBox30.amount * pizzaBoxes.pizzaBox30.price : 0) +
    (pizzaBoxes.pizzaBox40 ? pizzaBoxes.pizzaBox40.amount * pizzaBoxes.pizzaBox40.price : 0);
  

  const increaseItemAmount = (key) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.key === key ? { ...item, amount: item.amount + 1 } : item
      )
    );
  };

  const decreaseItemAmount = (key) => {
    setCart((prevCart) =>
      prevCart
        .map((item) =>
          item.key === key && item.amount > 1
            ? { ...item, amount: item.amount - 1 }
            : item
        )
        .filter((item) => item.amount > 0)
    );
  };

  const removeItem = (key) => {
    setCart((prevCart) => prevCart.filter((item) => item.key !== key));
  };

  const getProductByName = (name) => {
    return menu.find((product) =>
      product.name.toLowerCase().includes(name.toLowerCase())
    );
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        clearCart,
        totalPrice,
        increaseItemAmount,
        decreaseItemAmount,
        removeItem,
        pizzaBoxes,
        updatePizzaBoxes,
        getProductByName,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
